import React from 'react';
import "./styles/reviewPlatforms.css";

const ReviewPlatformsStep = ({ formData, updateFormData, reviewPlatforms }) => {

  // Use platformLinks keys as selected platforms
  const selectedPlatformIds = Object.keys(formData.platformLinks || {});

  const togglePlatform = (platformId) => {
    const updatedPlatformLinks = { ...formData.platformLinks || {} };
    if (selectedPlatformIds.includes(platformId)) {
      // Deselect: remove the platform
      delete updatedPlatformLinks[platformId];
    } else {
      // Select: add the platform with empty string
      updatedPlatformLinks[platformId] = '';
    }
    updateFormData('platformLinks', updatedPlatformLinks);
  };

  const handleLinkChange = (platformId, url) => {
    const updatedPlatformLinks = { ...formData.platformLinks || {} };
    updatedPlatformLinks[platformId] = url;
    updateFormData('platformLinks', updatedPlatformLinks);
  };

  return (
    <div className="step-content">
      <h2>Select Review Platforms</h2>
      <div className="platform-grid">
        {reviewPlatforms.map((platform) => (
          <div key={platform.id} className="platform-item">
            <div
              className={`platform-option ${selectedPlatformIds.includes(platform.id) ? 'selected' : ''}`}
              onClick={() => togglePlatform(platform.id)}
            >
              {platform.name}
            </div>
          </div>
        ))}
      </div>
      {reviewPlatforms.map((platform) => (
        selectedPlatformIds.includes(platform.id) && (
          <div key={platform.id} className="platform-link-container glass-box">
            <label htmlFor={`link-input-${platform.id}`}>Add link info for {platform.name} </label>
            <input
              id={`link-input-${platform.id}`}
              type="text"
              className="platform-link-input"
              placeholder={` 🔗 Enter your ${platform.name} link`}
              value={(formData.platformLinks || {})[platform.id] || ''}
              onChange={(e) => handleLinkChange(platform.id, e.target.value)}
              pattern="https?://.+"
              title="Please enter a valid URL starting with http:// or https://"
              required
            />
          </div>
        )
      ))}
    </div>
  );
};

export default ReviewPlatformsStep;
